<template>
  <div class="icon-block">
    <!-- <div class="icon photo" @click="shareIns"></div> -->
    <div class="icon facebook" @click="shareFacebook"></div>
    <div class="icon twitter" @click="shareTwitter"></div>
  </div>
</template>
<script>
export default {
  props: {
    sharePath: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  methods: {
    // 分享到脸书
    shareFacebook() {
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' +
          encodeURIComponent(this.sharePath)
      )
    },
    // 分享到推特
    shareTwitter() {
      window.open(
        'https://twitter.com/intent/tweet?url=' +
          encodeURIComponent(this.sharePath),
        '_blank',
        'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350'
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShareBox.vue